import React, { Component } from 'react';
import wood_mac_logo from '../assets/WoodMac_logo_interim_RGB.png';
import { ILanguageStrings } from '../utils/languages/languages';

interface FooterProps {
  languageStrings: ILanguageStrings;
}

export class Footer extends Component<FooterProps, {}> {
  render() {
    return (
      <div className="Footer">
        <div className="powered">
          <p>
            {this.props.languageStrings.footer.poweredBy + ' '}
            <picture>
              <img src={wood_mac_logo} srcSet={wood_mac_logo} alt="Wood Mackenzie logo" />
            </picture>
          </p>
        </div>
        <div className="links">
          <ul>
            <li>
              <a href="https://www.woodmac.com/siteassets/wm_brand/policy-and-privacy-pdf/wm_sc_scip_tous_202367508.pdf" target="_blank" rel="noreferrer">
                {this.props.languageStrings.footer.termsOfUse}
              </a>
            </li>
            <li>
              <a href="https://www.woodmac.com/siteassets/wm_brand/policy-and-privacy-pdf/wm-sc-scip-privacy-statement-202367478.pdf" target="_blank" rel="noreferrer">
                {this.props.languageStrings.footer.privacyStatement}
              </a>
            </li>
            <li>
              <a href="mailto:support@poweradvocate.com">{this.props.languageStrings.footer.contactSupport}</a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Footer;
